import React from 'react';
import { Link } from 'react-router-dom';
import PageHero from '../components/PageHero';
import FinalCTA from '../components/FinalCTA';
import Seo from '../components/Seo';
import { Calendar, RefreshCw, Mail } from 'lucide-react';
import { CONTACT } from '../mock';

export default function ExistingClients() {
  return (
    <>
      <Seo
        title="Existing Clients"
        description="Book your next session, reschedule, or contact your therapist at Chesapeake Counseling Center."
        path="/existing-clients"
      />
      <PageHero
        eyebrow="Existing Clients"
        title="Welcome"
        highlight="Back"
        subtitle="Schedule your next session, update your information, or get in touch with your therapist."
        crumbs={[{ label: 'Home', to: '/' }, { label: 'Existing Clients' }]}
      />
      <section className="section-pad" style={{ background: 'var(--warm-white)' }}>
        <div className="max-w-5xl mx-auto px-6 md:px-10 grid md:grid-cols-3 gap-6">
          {[
            { Icon: Calendar, title: 'Book Next Session', text: 'Reach out to schedule your follow-up appointment.', to: '/schedule' },
            { Icon: RefreshCw, title: 'Reschedule', text: 'Need to move an appointment? We’ll help find a new time.', to: '/contact' },
            { Icon: Mail, title: 'Contact Your Therapist', text: 'Send a secure message through our office.', to: '/contact' },
          ].map(({ Icon, title, text, to }) => (
            <Link to={to} key={title} className="card-soft p-7 group">
              <div className="w-12 h-12 rounded-2xl serviceCard-icon flex items-center justify-center mb-4 transition-transform group-hover:scale-110">
                <Icon className="w-5 h-5 text-[color:var(--dusty-rose)]" strokeWidth={1.5} />
              </div>
              <h3 className="font-serif-display text-xl text-[color:var(--deep-sage)] mb-2">{title}</h3>
              <p className="text-sm text-[color:var(--taupe-gray)] leading-relaxed">{text}</p>
            </Link>
          ))}
        </div>
        <div className="text-center mt-10 text-sm text-[color:var(--taupe-gray)]">
          Prefer to call? <a href={CONTACT.phoneHref} className="link-underline">{CONTACT.phone}</a>
        </div>
      </section>
      <FinalCTA />
    </>
  );
}
